import { getStyles } from "./lib";
import "./styles/index.scss";

export {
  StyleProps,
  SpacingName,
  getStyles,
  getColor,
  getTextColor,
  getFontSize,
  getFontWeight,
  getFontLineHeight,
  getBackgroundColor,
  getSpacing,
  getBorderRadius
} from "./lib";

export const bgPrimary = getStyles({
  background: {
    color: "PRIMARY"
  }
});
export const bgBrandPrimary = getStyles({
  background: {
    color: "BRAND_PRIMARY"
  }
});
export const bgTertiary = getStyles({
  background: {
    color: "TERTIARY"
  }
});
export const TBPADDINGX050 = getStyles({
  padding: ["X0_50", "X0", "X0_50", "X0"]
});
export const LRMARX050 = getStyles({
  margin: ["X0", "X0_50", "X0", "X0_50"]
});
export const LRPADDINGX050 = getStyles({
  padding: ["X0", "X0_50", "X0", "X0_50"]
});
export const LTRPADDINGX1 = getStyles({
  padding: ["X1", "X1", "X0", "X1"]
});
export const LTBPADDINGX1 = getStyles({
  padding: ["X1", "X0", "X1", "X1"]
});
export const LBRPADDINGX1 = getStyles({
  padding: ["X0", "X1", "X1", "X1"]
});

export const ALLMARX0 = getStyles({
  margin: ["X0", "X0", "X0", "X0"]
});
export const ALLMARX1 = getStyles({
  margin: ["X1"]
});
export const TRBMARX1 = getStyles({
  margin: ["X1", "X1", "X1", "X0"]
});
export const LBMARX1 = getStyles({
  margin: ["X0", "X0", "X1", "X1"]
});
export const TOPMARX050 = getStyles({
  margin: ["X0_50", "X0", "X0", "X0"]
});
export const TOPBOTTOMMARX050 = getStyles({
  margin: ["X0_50", "X0", "X0_50", "X0"]
});
export const TOPMARBASE = getStyles({
  margin: ["BASE", "X0", "X0", "X0"]
});
export const TOPMARX150 = getStyles({
  margin: ["X1_50", "X0", "X0", "X0"]
});
export const TOPMARX025 = getStyles({
  margin: ["X0_25", "X0", "X0", "X0"]
});
export const RIGHTMARX02 = getStyles({
  margin: ["X0", "X2", "X0", "X0"]
});
export const BOTTOMMARX1 = getStyles({
  margin: ["X0", "X0", "X1", "X0"]
});
export const BOTTOMMARX0_25 = getStyles({
  margin: ["X0", "X0", "X0_25", "X0"]
});
export const BOTTOMMARX0_50 = getStyles({
  margin: ["X0", "X0", "X0_50", "X0"]
});
export const LEFTMARX1 = getStyles({
  margin: ["X0", "X0", "X0", "X1"]
});
export const LEFTMARX0_50 = getStyles({
  margin: ["X0", "X0", "X0", "X0_50"]
});
export const LEFTMARX3 = getStyles({
  margin: ["X0", "X0", "X0", "X3"]
});
export const LEFTMARX2 = getStyles({
  margin: ["X0", "X0", "X0", "X2"]
});
export const BOTTOMPADX1 = getStyles({
  padding: ["X0", "X0", "X1", "X0"]
});
export const TOPPADDINGX050 = getStyles({
  padding: ["X0_50", "X0", "X0", "X0"]
});
export const textColorTertiary = getStyles({
  color: "TERTIARY"
});
export const textColorPrimary = getStyles({
  color: "PRIMARY"
});
export const textColorSecondary = getStyles({
  color: "SECONDARY"
});
export const textColorInteraction = getStyles({
  color: "INTERACTION"
});
export const textColorBrandPrimary = getStyles({
  color: "BRAND_PRIMARY"
});
export const textColorInversePrimary = getStyles({
  color: "INVERSE_PRIMARY"
});
export const lgBorderRad = getStyles({
  borderRadius: ["LG"]
});
export const mdBorderRad = getStyles({
  borderRadius: ["MD"]
});
export const fullBorderRad = getStyles({
  borderRadius: ["FULL"]
});
export const ALLPADX1 = getStyles({
  padding: ["X1"]
});
export const topBorderDefBase = getStyles({
  border: [{ width: "DEFAULT", color: "BASE" }, null, null, null]
});
export const bottomBorderDefBase = getStyles({
  border: [null, null, { width: "DEFAULT", color: "BASE" }, null]
});
export const bgSecondaryGrey = getStyles({
  background: {
    color: "SECONDARY"
  }
});
export const fontSmMedTight = getStyles({
  font: {
    family: "BASE",
    size: "SM",
    lineHeight: "TIGHT",
    weight: "MED"
  }
});
export const fontBaseRegLoose = getStyles({
  font: {
    family: "BASE",
    size: "BASE",
    weight: "REG",
    lineHeight: "LOOSE"
  }
});
export const fontXsRegTight = getStyles({
  font: {
    family: "BASE",
    size: "XS",
    weight: "REG",
    lineHeight: "TIGHT"
  }
});
export const fontXsRegFlat = getStyles({
  font: {
    family: "BASE",
    size: "XS",
    lineHeight: "FLAT",
    weight: "REG"
  }
});
export const fontSmRegFlat = getStyles({
  font: {
    family: "BASE",
    size: "SM",
    lineHeight: "FLAT",
    weight: "REG"
  }
});
export const fontSmRegLoose = getStyles({
  font: {
    family: "BASE",
    size: "SM",
    lineHeight: "LOOSE",
    weight: "REG"
  }
});
export const fontXl4BoldLoose = getStyles({
  font: {
    family: "BASE",
    size: "XL_4",
    lineHeight: "LOOSE",
    weight: "BOLD"
  }
});
export const fontXl3MedLoose = getStyles({
  font: {
    size: "XL_3",
    weight: "MED",
    lineHeight: "LOOSE",
    family: "BASE"
  }
});
export const fontXl3BoldLoose = getStyles({
  font: {
    size: "XL_3",
    weight: "BOLD",
    lineHeight: "LOOSE",
    family: "BASE"
  }
});
export const fontBaseMedLoose = getStyles({
  font: {
    size: "BASE",
    weight: "MED",
    lineHeight: "LOOSE",
    family: "BASE"
  }
});
export const fontXlMedLoose = getStyles({
  font: {
    size: "XL",
    weight: "MED",
    lineHeight: "LOOSE",
    family: "BASE"
  }
});
export const fontRootMedLoose = getStyles({
  font: {
    family: "BASE",
    size: "ROOT",
    weight: "MED",
    lineHeight: "LOOSE"
  }
});
export const fontRootMedTight = getStyles({
  font: {
    family: "BASE",
    size: "ROOT",
    weight: "MED",
    lineHeight: "TIGHT"
  }
});
export const fontBaseMedTight = getStyles({
  font: {
    family: "BASE",
    lineHeight: "TIGHT",
    weight: "MED",
    size: "ROOT"
  }
});
